import { render, staticRenderFns } from "./CasePreview.vue?vue&type=template&id=51fda45e&scoped=true"
import script from "./CasePreview.vue?vue&type=script&lang=js"
export * from "./CasePreview.vue?vue&type=script&lang=js"
import style0 from "./CasePreview.vue?vue&type=style&index=0&id=51fda45e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fda45e",
  null
  
)

export default component.exports